import { render, staticRenderFns } from "./_Favorite.vue?vue&type=template&id=67ebdbdb&scoped=true&"
import script from "./_Favorite.vue?vue&type=script&lang=js&"
export * from "./_Favorite.vue?vue&type=script&lang=js&"
import style0 from "./_Favorite.vue?vue&type=style&index=0&id=67ebdbdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ebdbdb",
  null
  
)

export default component.exports